var $ = global.jQuery = global.$;
var Form = require('./Form');
/**
 * Address lookup form
 * @class
 * @extends _Base
 */
var AddressForm = Form.extend(
  /** @lends Address.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.customValidation = {
      submitHandler: function() {
        self.saveAddress(self.getFieldValues());
      }
    };
    this._super();
    this.$primary = this.$el.find('[data-primary]');
    this.$invoice = this.$el.find('[data-invoice]');
    this.$submitButton = this.$el.find('button[type=submit]');
    this.$el.on('reset', function() {
      self.setFieldValues({
        IsPrimary: false,
        IsBilling: false
      });
      self.$primary.show();
      self.$invoice.show();
    });
    this.$el.on('Address:Updated', function(event, address) {
      self.setAddress(address);
    });
  },
  setFieldValues: function(fields) {
    this._super(fields);
    if (fields.IsPrimary) {
      this.$primary.hide();
    } else {
      this.$primary.show();
    }
    if (fields.IsBilling) {
      this.$invoice.hide();
    } else {
      this.$invoice.show();
    }
  },
  getFieldValues: function() {
    var fieldValues = this._super();
    delete fieldValues.searchFor;
    return fieldValues;
  },
  setAddress: function(address) {
    this.reset();
    this.setFieldValues(address);
  },
  saveAddress: function(address) {
    var self = this;
    this.$el.trigger('Loading:Start',['Saving address...']);
    return $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
      url: this.action,
      data: address
    })
      .done(function(response) {
        this.$el.trigger('Address:Saved', [response.Value]);
      }.bind(this));
  }
});

module.exports = AddressForm;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/AddressForm.js
// module id = 63
// module chunks = 0